import React from "react";
import Pagination from "./Pagination";
import ExceptionsTable from "./ExceptionsTable";
import {connect} from "react-redux";
import ClearButton from "./common/ClearButton";
import {gotDateUsers, gotExceptions} from "../actions/data";

const ExceptionsViewer = ({exceptions, isLastPage, filters, dispatch})=> {
    if (exceptions === undefined || !Array.isArray(exceptions) || exceptions.length === 0) {
        return null;
    }
    console.log(exceptions);
    return <div className='exceptions-container'>
        <ClearButton panel='exceptions'/>
        <Pagination type='exceptions' path='/exceptions' handleData={gotExceptions} lastPage={isLastPage}/>
        <ExceptionsTable rows={exceptions.length > filters.limit ? exceptions.slice(0, -1) : exceptions}/>
    </div>
};

const mapStateToProps=(state)=>({exceptions: state.data.exceptions, isLastPage: state.data.isLastPage, filters: state.filters});
const ConnectedExceptions=connect(mapStateToProps)(ExceptionsViewer);
export default ConnectedExceptions;